<template>
  <div class="contents">
    <div class="content_map">
      <MachineTar></MachineTar>
      <!-- <div class="tablist_item">
        减排机具地区分布
      </div> -->
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item v-if="this.$store.state.Code === '11'">
          <el-select
            placeholder="请选择区"
            v-model="search.countyCode"
            style="width: 150px"
            clearable
          >
            <el-option
              v-for="(item, index) in countyList"
              :key="index"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select
            placeholder="请选择机具类型"
            v-model="search.machineType"
            style="width: 150px"
            clearable
          >
            <el-option label="拖拉机" :value="1">拖拉机</el-option>
            <el-option label="收获机" :value="2">收获机</el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
        </el-form-item>
      </el-form>
      <div class="tabar_item">
        <div
          class="itemsE"
          :class="[{ active: activeNameE == item.name }]"
          v-for="item in itemListData"
          :key="item.id"
          @click="tabItemDataClick(item)"
        >
          {{ item.name }}
        </div>
      </div>
      <div v-if="MachinesToolsShow">
        <MachinesTools :search="search"></MachinesTools>
      </div>
      <div v-if="WorkAreaShow">
        <WorkArea :search="search"></WorkArea>
      </div>
      <div v-if="RoadMileageShow">
        <RoadMileage :search="search"></RoadMileage>
      </div>
      <div v-if="DrivingReductionShow">
        <DrivingReduction :search="search"></DrivingReduction>
      </div>
      <div v-if="OperatingMileageShow">
        <OperatingMileage :search="search"></OperatingMileage>
      </div>
      <div v-if="ReductionOperationShow">
        <ReductionOperation :search="search"></ReductionOperation>
      </div>
    </div>
  </div>
</template>
<script>
// Emission reduction by operation
import MachineTar from "./MachineTar.vue"
import Http from "../../Serves/net-http.js";
import Api from "../../Serves/net-api.js";
import MachinesTools from './ReductionEquipment/MachinesTools' // 减排机具总量
import WorkArea from './ReductionEquipment/WorkArea' // 作业面积
import RoadMileage from './ReductionEquipment/RoadMileage' // 道路行驶里程
import DrivingReduction from './ReductionEquipment/DrivingReduction' // 行驶减排量
import OperatingMileage from './ReductionEquipment/OperatingMileage' // 田间作业里程
import ReductionOperation from './ReductionEquipment/ReductionOperation' // 作业减排量
export default {
  components: {
    MachineTar,
    MachinesTools,
    WorkArea,
    RoadMileage,
    DrivingReduction,
    OperatingMileage,
    ReductionOperation
  },
  data() {
    return {
      search: {
        countyCode: '',
        machineType: ''
      },
      countyList: [],
      activeNameE: "减排机具总量",
      itemId: '',
      itemListData: [
        {
          id: 1,
          name: "减排机具总量"
        },
        {
          id: 2,
          name: "作业面积"
        },
        {
          id: 3,
          name: "道路行驶里程"
        },
        {
          id: 4,
          name: "行驶减排量"
        },
        {
          id: 5,
          name: "田间作业里程"
        },
        {
          id: 6,
          name: "作业减排量"
        }
      ],
      MachinesToolsShow: true,
      WorkAreaShow: false,
      RoadMileageShow: false,
      DrivingReductionShow: false,
      OperatingMileageShow: false,
      ReductionOperationShow: false
    }
  },
  mounted() {
    if (this.$store.state.Code === '11') {
      this.getCountyList(this.$store.state.info.provCode);
    }
  },
  methods: {
    getCountyList(value) {
      var url = Http.test + "/area/getCountyOfProvinceForMunicipality"
      Api.doPost(url, { provCode: value }, false, res => {
        this.countyList = res.result
      })
    },
    handleSearch() {
      if (this.activeNameE === '减排机具总量'){
        this.bus.$emit('search', { search: this.search })
      } else if (this.activeNameE === '作业面积'){
        this.bus.$emit('search1', { search: this.search })
      } else if (this.activeNameE === '道路行驶里程'){
        this.bus.$emit('search2', { search: this.search })
      } else if (this.activeNameE === '行驶减排量'){
        this.bus.$emit('search3', { search: this.search })
      } else if (this.activeNameE === '田间作业里程'){
        this.bus.$emit('search4', { search: this.search })
      } else if (this.activeNameE === '作业减排量'){
        this.bus.$emit('search5', { search: this.search })
      }
    },
    tabItemDataClick(item) {
      this.activeNameE = item.name
      this.itemId = item.id
      if (item.id === 1) {
        this.MachinesToolsShow = true
        this.WorkAreaShow = false
        this.RoadMileageShow = false
        this.DrivingReductionShow = false
        this.ReductionOperationShow = false
        this.OperatingMileageShow = false
      } else if (item.id === 2) {
        this.WorkAreaShow = true
        this.MachinesToolsShow = false
        this.RoadMileageShow = false
        this.DrivingReductionShow = false
        this.ReductionOperationShow = false
        this.OperatingMileageShow = false
      } else if (item.id === 3) {
        this.RoadMileageShow = true
        this.WorkAreaShow = false
        this.MachinesToolsShow = false
        this.DrivingReductionShow = false
        this.ReductionOperationShow = false
        this.OperatingMileageShow = false
      } else if (item.id === 4) {
        this.DrivingReductionShow = true
        this.RoadMileageShow = false
        this.WorkAreaShow = false
        this.MachinesToolsShow = false
        this.ReductionOperationShow = false
        this.OperatingMileageShow = false
      } else if (item.id === 5) {
        this.OperatingMileageShow = true
        this.DrivingReductionShow = false
        this.RoadMileageShow = false
        this.WorkAreaShow = false
        this.MachinesToolsShow = false
        this.ReductionOperationShow = false
      } else if (item.id === 6) {
        this.ReductionOperationShow = true
        this.OperatingMileageShow = false
        this.DrivingReductionShow = false
        this.RoadMileageShow = false
        this.WorkAreaShow = false
        this.MachinesToolsShow = false
      }
    }
  }
};
</script>
<style scoped lang="less">
.contents {
  width: 100%;
  /* height: 100%; */
  /* margin: 0 auto; */
}

.content_map {
  width: 98%;
  margin: 0 auto;
}
.tablist_item {
  display: flex;
  margin-bottom: 10px;
  margin-top: 10px;
}
.tabar_item {
  width: 100%;
  margin-top: 1vw;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  /* justify-content: center; */
}
.itemsE {
  width: 7vw;
  height: 3.5vh;
  /* padding: 0.2vw 1.5vw; */
  color: #ffffff;
  line-height: 3.5vh;
  text-align: center;
  margin-right: 10px;
  cursor: pointer;
  background-color: #1643a2;
  /* border: 1px solid #1643a2; */
  color: #ffffff;
  font-size: 0.8vw;
  text-align: center;
  margin-right: 10px;
  border-radius: 1.7vw;
  cursor: pointer;
}
.itemsE.active {
  width: 7vw;
  height: 3.5vh;
  /* padding: 0.2vw 1.5vw; */
  color: #ffffff;
  line-height: 3.5vh;
  text-align: center;
  margin-right: 10px;
  cursor: pointer;
  font-size: 0.8vw;
  text-align: center;
  margin-right: 10px;
  border-radius: 1.7vw;
  cursor: pointer;
  background-color: #f4f4f4;
  color: #000;
}
.items {
  height: 2.3vw;
  padding: 0 1vw;
  background-color: #0048c2;
  color: #ffffff;

  font-size: 0.8vw;
  text-align: center;
  line-height: 2.3vw;
  margin-right: 10px;
  border-radius: 0.2vw;
  cursor: pointer;
}
.items.active {
  height: 2.3vw;
  background-color: #f4f4f4;
  color: #000;
  font-size: 0.8vw;
  text-align: center;
  line-height: 2.3vw;
  border-radius: 0.2vw;
}
/deep/ input.el-input__inner,
.el-cascader__dropdown {
  background-color: #0b1680 !important;
  border: 1px solid #1643a2 !important;
}
/deep/ .tablist_item .el-range-editor.el-input__inner {
  background-color: #0b1680 !important;
  border: 1px solid #1643a2 !important;
}

/deep/ .tablist_item .el-date-editor .el-range-input {
  background-color: #0b1680 !important;
}

</style>



// WEBPACK FOOTER //
// src/components/MachineryDistribution/ToolDistribution.vue